class RedirectPayloadError extends Error {
  constructor(message) {
    super(message);
    this.name = "RedirectPayloadError";
    this.message = message;
    this.type = "payload_error";
  }
}

export default RedirectPayloadError;
